import Card from "../shared/Card";
import { fetchBody } from '../../utils/fetch';
import ButtonFunction from '../shared/ButtonFunction';
import TextInputHorizontalTag from "../shared/TextInputHorizontalTag";
import { useState, useContext } from "react";
import GeneralContext from "../../context/GeneralContext";
import {motion} from 'framer-motion';

function PasswordReset() {

    const {
        changeUserMenu,
        changeModalTitle,
        changeModalText,
        changeModalType
    } = useContext(GeneralContext);

    const [password, setPassword] = useState("");
    const changePassword = (e) => {
        setPassword(e.target.value);
    }

    const [passwordConfirm, setPasswordConfirm] = useState("");
    const changePasswordConfirm = (e) => {
        setPasswordConfirm(e.target.value);
    }

    const newPasswordFunction = async () => {
        const modal = document.getElementById("myModal");
        if (password === '' || passwordConfirm === '') {
            changeModalTitle('Error');
            changeModalText('Los campos no pueden estar vacíos');
            changeModalType('alert');
            modal.style.display = "block";
        } else {
            if (password !== passwordConfirm) {
                changeModalTitle('Error');
                changeModalText('Las contraseñas no coinciden');
                changeModalType('alert');
                modal.style.display = "block";
                return false;
            }
            const data = {password: password};
            const response = await fetchBody('change_forgotten_password_user', 'PUT', data);
            if (response.success) {
                changeModalTitle('Éxito!');
                changeModalText('Las contraseñas se ha restablecido exitosamente');
                changeModalType('alert');
                modal.style.display = "block";
                changeUserMenu('user');
            } else {
                changeModalTitle('Error al intentar la operación');
                changeModalText(response.reason);
                changeModalType('alert');
                modal.style.display = "block";
            }
        }
    }

  return (
    <motion.div
      id='resetCard'
      key='userReset'
      initial={{opacity: 0, x: -1000}}
      animate={{opacity: 1, x: 0}}
      exit={{opacity: 0, x: -1000}}
      transition={{duration: 0.5}}>
        <Card hasBackNavigation={true} backNavigationFunction={changeUserMenu} backNavigationTarget={'user'}>
            <h2>Ingrese la nueva contraseña</h2>
            <TextInputHorizontalTag label='Contraseña' type='password' changeEvent={changePassword}/>
            <TextInputHorizontalTag label='Confirmar contraseña' type='password' changeEvent={changePasswordConfirm}/>
            <br />
            <ButtonFunction buttonClass='loginButton' buttonFunction={newPasswordFunction}>Restablecer</ButtonFunction>
        </Card>
    </motion.div>
  )
}

export default PasswordReset